<template>
  <div class="log">

    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">收货地址</p>
      </div>
    </header>
    <div class="personalMain">
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">收货人</p>
        <p> <input class="inforNameInput" type="text" placeholder="请填写收货人姓名" ></p>
        <p><van-icon name="manager-o" /></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">手机号码</p>
        <p> <input class="inforNameInput" type="text" placeholder="请填写收货人手机号" ></p>
        <p></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">所在地区</p>
        <p> <input class="inforNameInput" type="text" placeholder="请填写收货人手机号" ></p>
        <p></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">所在地区</p>
        <p>
          <van-field
            v-model="fieldValue"
            is-link
            readonly
            label="地区"
            placeholder="请选择所在地区"
            @click="show = true"
          />
          <van-popup v-model="show" round position="bottom">
            <van-cascader
              v-model="cascaderValue"
              title="请选择所在地区"
              :options="option"
              @close="show = false"
              @change="onChange"
              @finish="onFinish"
            />
          </van-popup>
        </p>
        <p></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">所在地区</p>
        <p>
          <!--<van-field-->
            <!--v-model="value"-->
            <!--is-link-->
            <!--readonly-->
            <!--label="地区"-->
            <!--placeholder="请选择所在地区"-->
            <!--@click="show = true"-->
          <!--/>-->
          <!--<van-popup v-model="show" round position="bottom">-->
            <!--<van-cascader-->
              <!--v-model="valueList"-->
              <!--title="请选择所在地区"-->
              <!--:options="options"-->
              <!--@close="show = false"-->
              <!--@finish="onFinish"-->
            <!--/>-->
          <!--</van-popup>-->
        </p>
      </div>


    </div>
    <div class="buttonSave">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="addWorker()">保存</van-button>

    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        show: false,
        fieldValue: '',
        cascaderValue: '',
        value:"",
        valueList:"",
        // 选项列表，children 代表子选项，支持多级嵌套
        options: [
          {
            text: '浙江省',
            value: '01',
            children: [
              {
                text: '江',
                value: '1',

              },
            ],
          },
          {
            text: '江苏省',
            value: '02',

          },
        ],
        option:[],
        list:[],
        data : [{
          a: 11,
          b: 22,
          c: {
            a: 11,
            b: 22,
//            c:{.....}
        }
      }],
        arr:[]
      };

    },
    methods:{
      findDep(node = [],arr=[]) {
        for(let item of node) {
          arr.push({a: item.a,b: item.b})
          //将c对象存进数组，便于递归遍历
          let parentArr = []
          if(item.c) parentArr.push(item.c)
          if(parentArr && parentArr.length) this.findDep(parentArr,arr)
        }
        return arr
      },
      backHistory(){
        this.$router.go(-1)
      },
      onChange({ value }) {
        console.log(value)
        console.log(this.valueList)
        let _this=this
        _this.option.forEach(function (item,index) {
          if (value == item.value) {
            _this.$api.selectRegion({
              pid:value
            }).then(res=>{
              let arr=[]
              console.log(res.data.length!=0)
//              if(res.data.length) return
              if(res.data.length !=0 ){
                res.data.forEach(function (a,b) {
                  arr.push({text:a.name,value:a.id,pid:a.pid,children:[]})
                })
                item.children=arr
              }

//
            })
          }
        })
        console.log(this.option)
      }
      ,
      onFinish({ selectedOptions }) {
        console.log(this.value)
        console.log(this.valueList)
        console.log(selectedOptions)
        this.show = false;
//        this.value = selectedOptions.map((option) =>{
//          return option.text
//        } )
        this.value=["11","22"]
        console.log(this.value)
//        this.fieldValue = selectedOptions.map((option) => option.text).join('/');
      },
      selectRegioner(){
        this.$api.selectRegion({
          pid:""
        }).then(res=>{
//          this.$router.push("/editResume")

          this.list=res.data
          let _this=this
          this.list.forEach(function (item,index) {
            _this.option.push({text:item.name,value:item.id,pid:item.pid,children:[]})
          })
        })
          .catch(err=>{
        })
      },
    },
    mounted(){
      this.selectRegioner()
      this.findDep(this.data,this.arr)
    }
  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 60px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 60px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    /*font-size: 13px;*/
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
  .buttonSave{
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/address.vue